import {
  Card,
  Space,
  Row,
  Col,
  Modal,
  Input,
  Button,
  Form,
  DatePicker,
  message,
  Table,
  Select,
  Image,
  Empty,
  Tooltip as AntTooltip,
} from "antd";
import React from "react";
// import { Bar, Column } from "@ant-design/plots";
import MaintenanceDashboardStore from "../store/MaintenanceDashboardStore";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import { decode as base64_decode } from "base-64";
import Battery from "../assets/images/NewDesign/MaintenanceDashboard/Battery.svg";
import Maintenance from "../assets/images/NewDesign/MaintenanceDashboard/Maintenance.svg";
import carOil from "../assets/images/NewDesign/MaintenanceDashboard/Car oil.svg";
import LegalDocument from "../assets/images/NewDesign/MaintenanceDashboard/Legal document.svg";
import Wheel from "../assets/images/NewDesign/MaintenanceDashboard/Wheel.svg";

import {
  CartesianGrid,
  Cell,
  BarChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Bar,
} from "recharts";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import conf from "../config";
import ResizableTable from "./ResizableTable";

class MaintenanceDashboard extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      serviceReminder: false,
      tyerChangeReminder: false,
      oilChangeReminder: false,
      istimaraInsurance: false,
      insuranceReminder: false,
      batteryChangeReminder: false,
      driverOrVehicleSearchArray: [],
      driverOrVehicleSearchArrayfortire: [],
      driverOrVehicleSearchArrayforoil: [],
      driverOrVehicleSearchArrayforistimara: [],
      driverOrVehicleSearchArrayforinsurance: [],
      driverOrVehicleSearchArrayforbattery: [],
      openactionmodal: false,
      openactiofortyre: false,
      openactionforoil: false,
      vehicleid: "",
      status: "",
      dueLimitTyre: 1,
      dueLimit: 1,

      columns1: [
        {
          // title: "Vehicle Id",
          title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
          dataIndex: "vehicleId",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"),
          dataIndex: "vehicleNo",
          width: 8,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "driverName",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Service Interval (km)",
          title: context.translate("_SERVICE_INTERVAL_"),
          dataIndex: "serviceIntervalKm",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Next Major Service Change(Km)",
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_NEXTMAJORSERVICE_"
          ),
          dataIndex: "nextService",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Current Odometer Value ",
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_CURRENTODOMETER_"
          ),
          dataIndex: "distance",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Status",
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
          dataIndex: "status",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
          render: (value, record) => {
            // return <>Service-{record.serviceStatus}:{record.distance}km</>
            var oilDiff1 = Number(record.nextService) - Number(record.distance);

            var oilStatus;
            if (oilDiff1 >= 0) {
              // return<> { "Oil Change - " + "OverDue:" + oilDiff1 + "km"}</>;

              return (
                <p>
                  Service <span style={{ color: "green" }}> Due:</span>{" "}
                  {Math.abs(oilDiff1)} km
                </p>
              );
            } else {
              // return<> { "Oil Change- " + "Due.: " + oilDiff1 + "km"}</>;
              return (
                <p>
                  Service <span style={{ color: "red" }}> OverDue:</span>{" "}
                  {oilDiff1 ? Math.abs(oilDiff1) : Math.abs(record.distance)}
                  km
                </p>
              );
            }
          },
        },
         {
         // title: "Action",
         title: context.translate("_ACTION_"),
         dataIndex: "action",
         width: 7,
         ellipsis: {
           showTitle: true,
         },
         align: "center",
         render: (value, record) => {
           return (
             <img
               src={require("../assets/images/action-icon.png")}
               onClick={() => {
                 this.setState({
                   openactionmodal: true,
                   vehicleid: record.vehicleId,
                 });
               }}
             ></img>
           );
         },
         width: 5,
       },
      ],

      columns2: [
        {
          title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
          dataIndex: "vehicleId",

          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"),
          dataIndex: "vehicleNo",
          width: 8,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "driverName",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate("_TIRE_CHANGE_KM_"),
          dataIndex: "tireChangeInterval",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate("_NEXT_TYRE_CHANGE_KM_"),
          dataIndex: "nextTire",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_CURRENTODOMETER_"
          ),
          dataIndex: "distance",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_TYRE_"),
          dataIndex: "lastDistanceTire",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_TYRE_DATE_"
          ),
          dataIndex: "lastTireDate",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Status",
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
          dataIndex: "status",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
          render: (value, record) => {
            // return <>Service-{record.serviceStatus}:{record.distance}km</>
            //   var oilDiff1 = record.nextOil - record.distance;

            //   var oilStatus;
            //   if (oilDiff1 < 0) {
            //     // return<> { "Oil Change - " + "OverDue:" + oilDiff1 + "km"}</>;
            //     return <p>Tire Change -<span style={{ color: 'red' }}> OverDue:</span> {oilDiff1}+ "km"</p>;
            //   } else {
            //     // return<> { "Oil Change- " + "Due.: " + oilDiff1 + "km"}</>;
            //     return <p>Tire Change -<span style={{ color: 'green' }}> Due:</span> {oilDiff1}+ "km"</p>;
            //   }
            // },
            var oilDiff1 = Number(record.nextTire) - Number(record.distance);

            var oilStatus;
            if (oilDiff1 >= 0) {
              return (
                <p>
                  Tire Change <span style={{ color: "green" }}> Due:</span>{" "}
                  {Math.abs(oilDiff1)} km
                </p>
              );
            } else {
              return (
                <p>
                  Tire Change -<span style={{ color: "red" }}> OverDue:</span>{" "}
                  {oilDiff1 ? Math.abs(oilDiff1) : Math.abs(record.distance)}
                  km
                </p>
              );
            }
          },
        },
        {
          // title: "Action",
          title: context.translate("_ACTION_"),
          dataIndex: "action",
          width: 5,
          ellipsis: {
            showTitle: true,
          },
          align: "center",
          render: (value, record) => {
            return (
              <img
                src={require("../assets/images/action-icon.png")}
                onClick={() => {
                  this.setState({
                    openactiofortyre: true,
                    vehicleid: record.vehicleId,
                  });
                }}
              ></img>
            );
          },
        },
      ],
      columns3: [
        {
          title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
          dataIndex: "vehicleId",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate("_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"),
          dataIndex: "vehicleNo",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "driverName",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate("_OIL_CHANGE_INTERVAL_"),
          dataIndex: "oilChangeInterval",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_NEXTOILCHANGE_"
          ),
          dataIndex: "nextOil",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_CURRENTODOMETER_"
          ),
          dataIndex: "distance",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_OIL_KM_"
          ),
          dataIndex: "lastDistanceOil",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          title: context.translate(
            "_FLEET_VEHICLE_VEHICLEDETAIL_LASTOILCHANGE_DATE_"
          ),
          dataIndex: "lastOilDate",
          width: 12,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Status",
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
          dataIndex: "serviceStatus",
          width: 15,
          ellipsis: {
            showTitle: true,
          },
          render: (value, record) => {
            // var serviceDiff1=record.get('nextService') - record.get('distance');
            //            var serviceDiff = serviceDiff1.toString();
            //            var serviceStatus;

            //            var oilDiff1=record.get('nextOil') - record.get('distance');
            //             var oilDiff = oilDiff1.toString();
            //            var oilStatus;
            //            if(oilDiff< 0){
            //                oilStatus="Oil Change - "+"OverDue: ".fontcolor("red")+oilDiff.substring(1)+"km";
            //            }else{
            //                oilStatus="Oil Change- "+"Upcoming: ".fontcolor("green")+oilDiff+"km";
            //            }
            var oilDiff1 = Number(record.nextOil) - Number(record.distance);

            var oilStatus;
            if (oilDiff1 < 0) {
              return (
                <p>
                  Oil Change <span style={{ color: "red" }}> OverDue:</span>{" "}
                  {oilDiff1 ? Math.abs(oilDiff1) : 0} km
                </p>
              );
            } else {
              return (
                <p>
                  Oil Change -<span style={{ color: "green" }}> Upcoming:</span>{" "}
                  {/* {oilDiff1 ? Math.abs(oilDiff1) : Math.abs(record.distance)} */}
                  {oilDiff1 ? Math.abs(oilDiff1) : 0}Km
                </p>
              );
            }
          },
        },
        {
          // title: "Action",
          title: context.translate("_ACTION_"),
          dataIndex: "action",
          width: 5,
          ellipsis: {
            showTitle: true,
          },
          align: "center",
          render: (value, record) => {
            return (
              <img
                src={require("../assets/images/action-icon.png")}
                onClick={() => {
                  this.setState({
                    openactioforoil: true,
                    vehicleid: record.vehicleId,
                  });
                }}
              ></img>
            );
          },
        },
      ],

      columns4: [
        {
          // title: "Vehicle Id",
          title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
          dataIndex: "vehicleId",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"),
          dataIndex: "vehicleNo",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "driverName",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Company Name",
          title: context.translate("_COMPANY_NAME_"),
          dataIndex: "name",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Istimara Renewal",
          title: context.translate("_MULKIYA_RENEWAL_"),

          // title: context.translate("_IASTIMARA_RENEWAL_"),
          dataIndex: "mulkiyaRenewal",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Status",
          // dataIndex: "status",
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
          dataIndex: "status",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
          // render: (value, record) => {
          //   return <>Service-{record.serviceStatus}:{record.distance}km</>
          // },
        },
        {
          // title: "Action",
          title: context.translate("_ACTION_"),
          dataIndex: "action",
          width: 5,
          align: "center",
          ellipsis: {
            showTitle: true,
          },
          render: (value, record) => {
            return (
              <img src={require("../assets/images/action-icon.png")}></img>
            );
          },
        },
      ],

      columns5: [
        {
          // title: "Vehicle Id",
          title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
          dataIndex: "vehicleId",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"),
          dataIndex: "vehicleNo",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "driverName",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Company Name",
          title: context.translate("_COMPANY_NAME_"),
          dataIndex: "name",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Insurance Renewal",
          title: context.translate("_INSURANCE_RENEWAL_"),
          dataIndex: "insuranceRenewal",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Status",
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
          dataIndex: "status",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Action",
          title: context.translate("_ACTION_"),
          dataIndex: "action",
          width: 5,
          align: "center",
          ellipsis: {
            showTitle: true,
          },
          render: (value, record) => {
            return (
              <img src={require("../assets/images/action-icon.png")}></img>
            );
          },
        },
      ],
      columns6: [
        {
          // title: "Vehicle Id",
          title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
          dataIndex: "vehicleId",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"),
          dataIndex: "vehicleNo",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "driverName",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Company Name",
          title: context.translate("_COMPANY_NAME_"),
          dataIndex: "name",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Battery Next Change Date",
          title: context.translate("_Battery_Next_Change_Date_"),
          dataIndex: "nextBatteryChange",
          width: 20,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Status",
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
          dataIndex: "status",
          width: 10,
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Action",
          title: context.translate("_ACTION_"),
          dataIndex: "action",
          width: 5,
          align: "center",
          ellipsis: {
            showTitle: true,
          },
          render: (value, record) => {
            return (
              <img src={require("../assets/images/action-icon.png")}></img>
            );
          },
        },
      ],
    };
    this.maintenanceDashboardStore = new MaintenanceDashboardStore();
    this.dashBoardCardCss = {
      height: "134px",
      width: "432px",
      padding: "14px",
      background: "#FF6F6F",
      color: "#E0E6ED",
    };
    this.COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
    this.data = [
      { name: "Group A", value: 400 },
      { name: "Group B", value: 300 },
      { name: "Group C", value: 300 },
      { name: "Group D", value: 200 },
    ];
    this.RADIAN = Math.PI / 180;
  }
  async handleChange() {
    await this.maintenanceDashboardStore.getData({
      companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      status: this.state.status,
    });

    await this.setState({
      driverOrVehicleSearchArray:
        this.maintenanceDashboardStore.serviceReminderData,
    });
    await this.setState({
      driverOrVehicleSearchArrayfortire:
        this.maintenanceDashboardStore.tyreReminderData,
    });
    await this.setState({
      driverOrVehicleSearchArrayforoil:
        this.maintenanceDashboardStore.oilReminderData,
    });
    await this.setState({
      driverOrVehicleSearchArrayforistimara:
        this.maintenanceDashboardStore.mulkiyaReminderData,
    });
    await this.setState({
      driverOrVehicleSearchArrayforinsurance:
        this.maintenanceDashboardStore.insuranceExpiryData,
    });
    await this.setState({
      driverOrVehicleSearchArrayforbattery:
        this.maintenanceDashboardStore.batteryExpiryData,
    });

    await this.setState({ loadData: 1 });
  }
  CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;

      return (
        <div
          style={{ border: "1px solid", background: "white", padding: "10px" }}
        >
          <div>{`Vehicle No: ${data.vehicleNo}`}</div>
          <div>{`Amount: ${data.sumAmount}`}</div>
        </div>
      );
    }
    return null;
  };
  piechart_tooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const label = payload[0].name;

      return (
        <div
          className="custom-tooltip"
          style={{ border: "1px solid", background: "white", padding: "10px" }}
        >
          <small className="label">{`${label}`}</small>
          <br />
        </div>
      );
    }
    return null;
  };

  handleSearchChange(query) {
    return this.maintenanceDashboardStore?.serviceReminderData?.filter(
      (vehicle) => {
        const normalizedQuery = query.toLowerCase();
        return (
          (vehicle.driverName &&
            vehicle.driverName.toLowerCase().includes(normalizedQuery)) ||
          (vehicle.vehicleNo &&
            vehicle.vehicleNo.toLowerCase().includes(normalizedQuery))
        );
      }
    );
  }
  handleSearchtyreremainder(query) {
    return this.maintenanceDashboardStore?.tyreReminderData?.filter(
      (vehicle) => {
        const normalizedQuery = query.toLowerCase();
        return (
          (vehicle.driverName &&
            vehicle.driverName.toLowerCase().includes(normalizedQuery)) ||
          (vehicle.vehicleNo &&
            vehicle.vehicleNo.toLowerCase().includes(normalizedQuery))
        );
      }
    );
  }
  handleSearchoilremainder(query) {
    return this.maintenanceDashboardStore?.oilReminderData?.filter(
      (vehicle) => {
        const normalizedQuery = query.toLowerCase();
        return (
          (vehicle.driverName &&
            vehicle.driverName.toLowerCase().includes(normalizedQuery)) ||
          (vehicle.vehicleNo &&
            vehicle.vehicleNo.toLowerCase().includes(normalizedQuery))
        );
      }
    );
  }
  handleSearchistimararemainder(query) {
    return this.maintenanceDashboardStore?.mulkiyaReminderData?.filter(
      (vehicle) => {
        const normalizedQuery = query.toLowerCase();
        return (
          (vehicle.driverName &&
            vehicle.driverName.toLowerCase().includes(normalizedQuery)) ||
          (vehicle.vehicleNo &&
            vehicle.vehicleNo.toLowerCase().includes(normalizedQuery))
        );
      }
    );
  }
  handleSearchinsuaranceremainder(query) {
    return this.maintenanceDashboardStore?.insuranceExpiryData?.filter(
      (vehicle) => {
        const normalizedQuery = query.toLowerCase();
        return (
          (vehicle.driverName &&
            vehicle.driverName.toLowerCase().includes(normalizedQuery)) ||
          (vehicle.vehicleNo &&
            vehicle.vehicleNo.toLowerCase().includes(normalizedQuery))
        );
      }
    );
  }
  handleSearchbatteryremainder(query) {
    return this.maintenanceDashboardStore?.batteryExpiryData?.filter(
      (vehicle) => {
        const normalizedQuery = query.toLowerCase();
        return (
          (vehicle.driverName &&
            vehicle.driverName.toLowerCase().includes(normalizedQuery)) ||
          (vehicle.vehicleNo &&
            vehicle.vehicleNo.toLowerCase().includes(normalizedQuery))
        );
      }
    );
  }

  handleSearchinsuranceremainder(query) {
    return this.maintenanceDashboardStore.insuranceExpiryData?.filter(
      (vehicle) => {
        const normalizedQuery = query.toLowerCase();
        return (
          (vehicle.driverName &&
            vehicle.driverName.toLowerCase().includes(normalizedQuery)) ||
          (vehicle.vehicleNo &&
            vehicle.vehicleNo.toLowerCase().includes(normalizedQuery))
        );
      }
    );
  }
  // closeModal() {
  //   this.setState({ openactionmodal: false })
  // }
  async componentDidMount() {
    const maintenanceDashboard =
      await this.maintenanceDashboardStore.getDashboardCount({
        companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
        isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      });
    // this.getDashBoardCount();

    const weeklyMaintenanceData =
      await this.maintenanceDashboardStore.getVehicleWeeklyGraph({
        companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
        isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      });

    const monthlyMaintenanceData =
      await this.maintenanceDashboardStore.getVehicleMonthlyGraph({
        companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
        isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      });

    await this.maintenanceDashboardStore.getMaintenancePieChart({
      companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
    });

    this.setState({ loadData: 1 });
  }

  getDashBoardCount() {
    setTimeout(() => {
      this.maintenanceDashboardStore.getDashboardCount({
        companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
        isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      });
      this.getDashBoardCount();
    }, 30000);
  }

  renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    name,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * this.RADIAN);
    const y = cy + radius * Math.sin(-midAngle * this.RADIAN);

    return (
      <text
        style={{ margin: "30px" }}
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  getColorByName = (name) => {
    // Add your conditions here
    if (name === "Oil") {
      return "#ff7976";
    } else if (name === "Tire") {
      return "#57caeb";
    } else if (name === "Service") {
      return "#157fcc";
    } else if (name === "Mulkiya") {
      return "rgb(93, 218, 180)";
    } else if (name === "Insurance") {
      return "rgb(255, 219, 88)";
    } else {
      return "rgb(235, 91, 187)";
    }
  };

  onActionSubmit = async (value) => {
    const data = {
      changeValue: value?.changeValue,
      changeValueServiceDate:
        value?.changeValueServiceDate.format("YYYY-MM-DD"),
      vehicleId: this.state.vehicleid,
      actionDateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    };

    const response = await this.maintenanceDashboardStore.addaction(data);

    if (response.data.success === "S") {
      message.success(response.data.message);
      this.setState({ loadList: 1 });
      this.handleChange();
      await this.setState({ openactionmodal: false });
    } else {
      await message.error(response.data.message);
    }
  };

  onActiontyreSubmit = async (value) => {
    const data = {
      changeValue: value?.changeValue,
      changeValueServiceDate:
        value?.changeValueServiceDate.format("YYYY-MM-DD"),
      vehicleId: this.state.vehicleid,
      actionDateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    };

    const response = await this.maintenanceDashboardStore.addactionfortyre(
      data
    );

    if (response.data.success === "S") {
      message.success(response.data.message);
      this.setState({ loadList: 1 });
      this.handleChange();
      await this.setState({ openactiofortyre: false });
    } else {
      await message.error(response.data.message);
    }
  };

  onActionOilSubmit = async (value) => {
    const data = {
      changeValue: value?.changeValue,
      changeValueServiceDate:
        value?.changeValueServiceDate.format("YYYY-MM-DD"),
      vehicleId: this.state.vehicleid,
      actionDateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    };

    const response = await this.maintenanceDashboardStore.addactionforoil(data);

    if (response.data.success === "S") {
      message.success(response.data.message);
      this.setState({ loadList: 1 });
      this.handleChange();
      await this.setState({ openactioforoil: false });
    } else {
      await message.error(response.data.message);
    }
  };
  updatedistanceAll = async ({ state }) => {
    const data = { vehicleIds: [], type: "tyreReminderAll" };
    const resp = await this.maintenanceDashboardStore.updatedistanceAll(data);
    if (resp.data.success === "S") {
      Modal.success({
        title: "Success",
        content: "Details Updated Successfully",
      });
      await this.setState({ [state]: false });
    }
  };

  handleResizeCol1 =
    (index) =>
    (_, { size }) => {
      this.setState((prevState) => {
        if (!Array.isArray(prevState.columns1)) return null;

        const newColumns = [...prevState.columns1];
        newColumns[index] = { ...newColumns[index], width: size.width };

        return { columns1: newColumns };
      });
    };

  getMergedColumns = (columns, tableKey) => {
    return columns.map((col, index) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: this.handleResizeCol(tableKey, index),
      }),
    }));
  };

  handleResizeCol = (tableKey, index) => {
    return (_, { size }) => {
      this.setState((prevState) => {
        const tableCols = prevState[tableKey];
        if (!Array.isArray(tableCols)) return null;

        const newColumns = [...tableCols];

        newColumns[index] = { ...newColumns[index], width: size.width };

        return { [tableKey]: newColumns };
      });
    };
  };

  render() {
    const mergedColumns1 = this.state.columns1.map((col, index) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: this.handleResizeCol1(index),
      }),
    }));

    return (
      <div
        className="maintainance-dash"
        style={{ height: "100vh", overflowY: "scroll", padding: 30 }}
      >
        <div>
          <div
            style={{
              gap: "20px",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Card
              className="maintenance-dashboard-tiles maintenance-reminder"
              onClick={async () => {
                await this.setState({
                  serviceReminder: true,
                  status: "Running",
                });
                await this.handleChange();
              }}
            >
              {/* Left Section */}
              <div className="maintainance_tile_content-left">
                <div className="icon-section">
                  {/* <i className="las la-tools"></i> */}
                  <Image src={Maintenance}></Image>
                </div>
                <div className="service-text">
                  <p className="service-count">
                    {
                      this.maintenanceDashboardStore?.maintenanceData
                        ?.totalService
                    }
                  </p>
                  <p className="service-label">
                    {this.context.translate("_SERVICE_REMINDER_")}
                  </p>
                </div>
              </div>

              {/* Right Section */}
              <div className="maintainance_tile_content-right">
                <div className="status-labels">
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.serviceUpcoming
                      }
                    </h6>
                    <p>{this.context.translate("_UPCOMING_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.serviceDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_DUE_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.serviceOverDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_OVERDUE_")}</p>
                  </span>
                </div>
                <div className="status-values"></div>
              </div>
            </Card>

            <Modal
              open={this.state.serviceReminder}
              centered
              width={1300}
              onCancel={() => this.setState({ serviceReminder: false })}
              footer={null}
            >
              <div style={{ height: "600px" }}>
                <div className="heading" style={{ marginBottom: "10px" }}>
                  {this.context.translate("_SERVICE_REMINDER_")}
                </div>

                <Row style={{ marginBottom: "10px", gap: "10px" }}>
                  <Space>
                    <Input
                      // placeholder="Search by Vehicle"
                      placeholder={this.context.translate(
                        "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                      )}
                      style={{ width: 300, height: "36px" }}
                      onChange={async (e) => {
                        let searchedArray = await this.handleSearchChange(
                          e.target.value
                        );

                        await this.setState({
                          driverOrVehicleSearchArray:
                            searchedArray?.length === 0 ? [] : searchedArray,
                        });
                      }}
                    />
                    <Button
                      disabled={
                        this.maintenanceDashboardStore?.serviceReminderData
                          ?.length > 0
                          ? false
                          : true
                      }
                      style={{
                        backgroundColor: conf.activeColor,
                        height: "36px",
                      }}
                      onClick={(val) => {
                        let result = [];
                        if (true) {
                          this.state.columns1.map((obj) =>
                            result.push(obj.dataIndex)
                          );

                          var getData = {
                            companyId: JSON.parse(
                              base64_decode(Cookies.get("data"))
                            ).userCompanyId,
                            userCompany: undefined,
                            vehicleStatus: this.state.status,
                            userId: JSON.parse(
                              base64_decode(Cookies.get("data"))
                            ).userId,
                            isadmin: JSON.parse(
                              base64_decode(Cookies.get("data"))
                            ).isadmin,
                            colList: result,
                          };

                          if (val) {
                            this.maintenanceDashboardStore.exportSerRemExcel(
                              getData
                            );
                          }
                        }
                      }}
                    >
                      {this.context.translate("_EXPORT_")}
                    </Button>

                    <AntTooltip
                      title={this.context.translate("_UPDATE_VALUES_")}
                      placement={"bottom"}
                    >
                      <Button
                        type="primary"
                        style={{ height: "36px" }}
                        onClick={() =>
                          this.updatedistanceAll({ state: "serviceReminder" })
                        }
                      >
                        <i class="bi bi-arrow-clockwise"></i>
                      </Button>
                    </AntTooltip>
                  </Space>
                </Row>

                <Table
                  components={{
                    header: {
                      cell: ResizableTable,
                    },
                  }}
                  pagination={false}
                  current={this.state.currentPage}
                  total={this.maintenanceDashboardStore?.total}
                  // columns={this.columns1}
                  columns={mergedColumns1}
                  dataSource={this.state.driverOrVehicleSearchArray}
                  loading={this.maintenanceDashboardStore?.loading}
                  onChange={this.handleTableChange}
                  scroll={{ y: 450 }}
                />
              </div>
            </Modal>

            <Card
              className="maintenance-dashboard-tiles tyreChange-reminder"
              onClick={async () => {
                await this.setState({
                  tyerChangeReminder: true,
                  status: "Idle",
                });
                await this.handleChange();
              }}
            >
              <div className="maintainance_tile_content-left">
                <div className="icon-section">
                  <Image src={Wheel}></Image>
                </div>
                <div className="service-text">
                  <p className="service-count">
                    {this.maintenanceDashboardStore?.maintenanceData?.totalTire}
                  </p>
                  <p className="service-label">
                    {this.context.translate("_TYRE_CHANGE_REAMINDER_")}
                  </p>
                </div>
              </div>

              {/* Right Section */}
              <div className="maintainance_tile_content-right">
                <div className="status-labels">
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.tireUpcoming
                      }
                    </h6>
                    <p>{this.context.translate("_UPCOMING_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {this.maintenanceDashboardStore?.maintenanceData?.tireDue}
                    </h6>{" "}
                    <p>{this.context.translate("_DUE_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.tireOverDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_OVERDUE_")}</p>
                  </span>
                </div>
                <div className="status-values"></div>
              </div>
            </Card>

            <Modal
              open={this.state.tyerChangeReminder}
              centered
              width={1300}
              onCancel={() => this.setState({ tyerChangeReminder: false })}
              footer={null}
            >
              <div style={{ height: "600px" }}>
                <div className="heading" style={{ marginBottom: "10px" }}>
                  {this.context.translate("_TYRE_CHANGE_REAMINDER_")}
                </div>
                <Row style={{ marginBottom: "10px", gap: "10px" }}>
                  <Input
                    // placeholder="Search by Vehicle"
                    placeholder={this.context.translate(
                      "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                    )}
                    style={{ width: 300, height: "36px" }}
                    onChange={async (e) => {
                      let searchedArray = await this.handleSearchtyreremainder(
                        e.target.value
                      );

                      await this.setState({
                        driverOrVehicleSearchArrayfortire:
                          searchedArray?.length === 0 ? [] : searchedArray,
                      });
                    }}
                    // onChange={(e) => { this.setState({ searchField: e.target.value }) }}
                  />

                  <Select
                    onSelect={async (val) => {
                      this.setState({ dueLimitTyre: val });
                      await this.maintenanceDashboardStore.getData({
                        companyId: JSON.parse(
                          base64_decode(Cookies.get("data"))
                        ).userCompanyId,
                        userId: JSON.parse(base64_decode(Cookies.get("data")))
                          .userId,
                        isadmin: JSON.parse(base64_decode(Cookies.get("data")))
                          .isadmin,
                        status: "Idle",
                        dueLimitTyre: this.state.dueLimitTyre,
                      });
                    }}
                    onChange={(val) => {}}
                    style={{ width: 150 }}
                    defaultValue={1}
                    className="dashboard-select"
                  >
                    <Select.Option value={1}>All</Select.Option>
                    <Select.Option value={2}>500 Km</Select.Option>
                    <Select.Option value={3}>1000 Km</Select.Option>
                    <Select.Option value={4}>2000 Km</Select.Option>
                    <Select.Option value={5}>5000 Km</Select.Option>
                  </Select>

                  <Button
                    disabled={
                      this.maintenanceDashboardStore?.tyreReminderData?.length >
                      0
                        ? false
                        : true
                    }
                    style={{
                      backgroundColor: conf.activeColor,
                      height: "36px",
                    }}
                    onClick={(val) => {
                      let result = [];
                      if (true) {
                        this.state.columns2.map((obj) =>
                          result.push(obj.dataIndex)
                        );

                        var getData = {
                          companyId: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).userCompanyId,
                          userCompany: undefined,
                          vehicleStatus: this.state.status,
                          userId: JSON.parse(base64_decode(Cookies.get("data")))
                            .userId,
                          isadmin: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).isadmin,
                          dueLimitTyre: this.state.dueLimitTyre,
                          colList: result,
                        };

                        if (val) {
                          this.maintenanceDashboardStore.exportTyreRemExcel(
                            getData
                          );
                        }
                      }
                    }}
                  >
                    {/* Export */}
                    {this.context.translate("_EXPORT_")}
                  </Button>

                  <AntTooltip
                    title={this.context.translate("_UPDATE_VALUES_")}
                    placement={"bottom"}
                  >
                    <Button
                      type="primary"
                      style={{ height: "36px" }}
                      onClick={() =>
                        this.updatedistanceAll({ state: "tyerChangeReminder" })
                      }
                    >
                      <i class="bi bi-arrow-clockwise"></i>
                    </Button>
                  </AntTooltip>
                </Row>

                <Table
                  components={{
                    header: {
                      cell: ResizableTable,
                    },
                  }}
                  pagination={false}
                  current={this.state.currentPage}
                  total={this.maintenanceDashboardStore?.total}
                  columns={this.getMergedColumns(
                    this.state.columns2,
                    "columns2"
                  )}
                  // columns={this.state.columns2}
                  // dataSource={this.maintenanceDashboardStore?.tyreReminderData}
                  dataSource={this.state.driverOrVehicleSearchArrayfortire}
                  loading={this.maintenanceDashboardStore?.loading}
                  onChange={this.handleTableChange}
                  scroll={{ y: 450 }}
                />
              </div>
            </Modal>

            <Card
              className="maintenance-dashboard-tiles oilChange-reminder"
              onClick={async () => {
                await this.setState({
                  oilChangeReminder: true,
                  status: "Stop",
                });
                await this.handleChange();
              }}
            >
              {/* Left Section */}
              <div className="maintainance_tile_content-left">
                <div className="icon-section">
                  <Image src={carOil}></Image>
                </div>
                <div className="service-text">
                  <p className="service-count">
                    {this.maintenanceDashboardStore?.maintenanceData?.totalOil}
                  </p>
                  <p className="service-label">
                    {this.context.translate("_OIL_CHANGE_REMINDER_")}
                  </p>
                </div>
              </div>

              {/* Right Section */}
              <div className="maintainance_tile_content-right">
                <div className="status-labels">
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.oilUpcoming
                      }
                    </h6>
                    <p>{this.context.translate("_UPCOMING_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {this.maintenanceDashboardStore?.maintenanceData?.oilDue}
                    </h6>{" "}
                    <p>{this.context.translate("_DUE_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.oilOverDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_OVERDUE_")}</p>
                  </span>
                </div>
                <div className="status-values"></div>
              </div>
            </Card>

            <Modal
              open={this.state.oilChangeReminder}
              centered
              width={1300}
              onCancel={() => this.setState({ oilChangeReminder: false })}
              footer={null}
            >
              <div style={{ height: "600px" }}>
                <div className="heading" style={{ marginBottom: "10px" }}>
                  {this.context.translate("_OIL_CHANGE_REMINDER_")}
                </div>
                <Row style={{ marginBottom: "10px", gap: "10px" }}>
                  <Input
                    // placeholder="Search by Vehicle"
                    placeholder={this.context.translate(
                      "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                    )}
                    style={{ width: 300, height: "36px" }}
                    // onChange={(e) => { this.setState({ searchField: e.target.value }) }}
                    onChange={async (e) => {
                      let searchedArray = await this.handleSearchoilremainder(
                        e.target.value
                      );
                      await this.setState({
                        driverOrVehicleSearchArrayforoil:
                          searchedArray.length === 0 ? [] : searchedArray,
                      });
                    }}
                  />

                  <Select
                    onSelect={async (val) => {
                      this.setState({ dueLimit: val });
                      await this.maintenanceDashboardStore.getData({
                        companyId: JSON.parse(
                          base64_decode(Cookies.get("data"))
                        ).userCompanyId,
                        userId: JSON.parse(base64_decode(Cookies.get("data")))
                          .userId,
                        isadmin: JSON.parse(base64_decode(Cookies.get("data")))
                          .isadmin,
                        status: "Stop",
                        dueLimit: this.state.dueLimit,
                      });
                    }}
                    onChange={(val) => {}}
                    style={{ width: 150 }}
                    defaultValue={1}
                    className="dashboard-select"
                  >
                    <Select.Option value={1}>All</Select.Option>
                    <Select.Option value={2}>500 Km</Select.Option>
                    <Select.Option value={3}>1000 Km</Select.Option>
                    <Select.Option value={4}>2000 Km</Select.Option>
                    <Select.Option value={5}>5000 Km</Select.Option>
                  </Select>
                  <Button
                    disabled={
                      this.maintenanceDashboardStore?.oilReminderData?.length >
                      0
                        ? false
                        : true
                    }
                    style={{
                      backgroundColor: conf.activeColor,
                      height: "36px",
                    }}
                    onClick={(val) => {
                      let result = [];
                      if (true) {
                        this.state.columns3.map((obj) =>
                          result.push(obj.dataIndex)
                        );

                        var getData = {
                          companyId: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).userCompanyId,
                          userCompany: undefined,
                          vehicleStatus: this.state.status,
                          userId: JSON.parse(base64_decode(Cookies.get("data")))
                            .userId,
                          isadmin: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).isadmin,
                          colList: result,
                        };

                        if (val) {
                          this.maintenanceDashboardStore.exportOilExcel(
                            getData
                          );
                        }
                      }
                    }}
                  >
                    {/* Export */}
                    {this.context.translate("_EXPORT_")}
                  </Button>

                  <AntTooltip
                    title={this.context.translate("_UPDATE_VALUES_")}
                    placement={"bottom"}
                  >
                    <Button
                      type="primary"
                      style={{ height: "36px" }}
                      onClick={() =>
                        this.updatedistanceAll({ state: "oilChangeReminder" })
                      }
                    >
                      <i class="bi bi-arrow-clockwise"></i>
                    </Button>
                  </AntTooltip>
                </Row>
                <div>
                  <Table
                    components={{
                      header: {
                        cell: ResizableTable,
                      },
                    }}
                    pagination={false}
                    current={this.state.currentPage}
                    total={this.maintenanceDashboardStore?.total}
                    columns={this.getMergedColumns(
                      this.state.columns3,
                      "columns3"
                    )}
                    // columns={this.state.columns3}
                    // dataSource={this.maintenanceDashboardStore?.oilReminderData}
                    dataSource={this.state.driverOrVehicleSearchArrayforoil}
                    loading={this.maintenanceDashboardStore?.loading}
                    // onChange={this.handleTableChange}
                    scroll={{ y: 450 }}
                  />
                </div>
              </div>
            </Modal>
          </div>
          <div
            style={{
              gap: "20px",
              display: "flex",
              justifyContent: "space-around",
              marginTop: "12px",
            }}
          >
            <Card
              className="maintenance-dashboard-tiles mulkiya-reminder"
              onClick={async () => {
                await this.setState({
                  istimaraInsurance: true,
                  status: "exIdle",
                });
                await this.handleChange();
              }}
            >
              {/* Left Section */}
              <div className="maintainance_tile_content-left">
                <div className="icon-section">
                  <Image src={LegalDocument}></Image>
                </div>
                <div className="service-text">
                  <p className="service-count">
                    {
                      this.maintenanceDashboardStore?.maintenanceData
                        ?.totalMulkiya
                    }
                  </p>
                  <p className="service-label">Mulkiya Reminder</p>
                </div>
              </div>

              {/* Right Section */}
              <div className="maintainance_tile_content-right">
                <div className="status-labels">
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.mulkiyaUpcoming
                      }
                    </h6>
                    <p>{this.context.translate("_UPCOMING_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.mulkiyaDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_DUE_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.mulkiyaOverDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_OVERDUE_")}</p>
                  </span>
                </div>
                <div className="status-values"></div>
              </div>
            </Card>

            <Modal
              open={this.state.istimaraInsurance}
              centered
              width={1300}
              onCancel={() => this.setState({ istimaraInsurance: false })}
              footer={null}
            >
              <div style={{ height: "600px" }}>
                <div className="heading" style={{ marginBottom: "10px" }}>
                  {this.context.translate("Mulkiya Reminder")}
                </div>
                <Row style={{ marginBottom: "10px", gap: "10px" }}>
                  <Input
                    // placeholder="Search by Vehicle"
                    placeholder={this.context.translate(
                      "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                    )}
                    style={{ width: 300, height: "36px" }}
                    onChange={async (e) => {
                      let searchedArray =
                        await this.handleSearchistimararemainder(
                          e.target.value
                        );

                      await this.setState({
                        driverOrVehicleSearchArrayforistimara:
                          searchedArray?.length === 0 ? [] : searchedArray,
                      });
                    }}
                    // onChange={(e) => { this.setState({ searchField: e.target.value }) }}
                  />

                  <Button
                    disabled={
                      this.maintenanceDashboardStore?.mulkiyaReminderData
                        ?.length > 0
                        ? false
                        : true
                    }
                    style={{
                      backgroundColor: conf.activeColor,
                      height: "36px",
                    }}
                    onClick={(val) => {
                      let result = [];
                      if (true) {
                        this.state.columns4.map((obj) =>
                          result.push(obj.dataIndex)
                        );

                        var getData = {
                          companyId: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).userCompanyId,
                          userCompany: undefined,
                          vehicleStatus: this.state.status,
                          userId: JSON.parse(base64_decode(Cookies.get("data")))
                            .userId,
                          isadmin: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).isadmin,
                          colList: result,
                        };

                        if (val) {
                          this.maintenanceDashboardStore.exportMulkiyaExcel(
                            getData
                          );
                        }
                      }
                    }}
                  >
                    {/* Export */}
                    {this.context.translate("_EXPORT_")}
                  </Button>

                  <AntTooltip
                    title={this.context.translate("_UPDATE_VALUES_")}
                    placement={"bottom"}
                  >
                    <Button
                      type="primary"
                      style={{ height: "36px" }}
                      onClick={() =>
                        this.updatedistanceAll({ state: "istimaraInsurance" })
                      }
                    >
                      <i class="bi bi-arrow-clockwise"></i>
                    </Button>
                  </AntTooltip>
                </Row>

                <Table
                  components={{
                    header: {
                      cell: ResizableTable,
                    },
                  }}
                  pagination={false}
                  current={this.state.currentPage}
                  total={this.maintenanceDashboardStore?.total}
                  // columns={this.state.columns4}
                  columns={this.getMergedColumns(
                    this.state.columns4,
                    "columns4"
                  )}
                  // dataSource={this.maintenanceDashboardStore?.mulkiyaReminderData}
                  dataSource={this.state.driverOrVehicleSearchArrayforistimara}
                  loading={this.maintenanceDashboardStore?.loading}
                  scroll={{ y: 450 }}
                />
              </div>
            </Modal>

            <Card
              className="maintenance-dashboard-tiles insurence-reminder"
              onClick={async () => {
                await this.setState({
                  insuranceReminder: true,
                  status: "NoData",
                });
                await this.handleChange();
              }}
            >
              {/* Left Section */}
              <div className="maintainance_tile_content-left">
                <div className="icon-section">
                  <Image src={LegalDocument}></Image>
                </div>
                <div className="service-text">
                  <p className="service-count">
                    {
                      this.maintenanceDashboardStore?.maintenanceData
                        ?.totalInsurance
                    }
                  </p>
                  <p className="service-label">
                    {this.context.translate("_INSURANCE_REMINDER_")}
                  </p>
                </div>
              </div>

              {/* Right Section */}
              <div className="maintainance_tile_content-right">
                <div className="status-labels">
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.insuranceUpcoming
                      }
                    </h6>
                    <p>{this.context.translate("_UPCOMING_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.insuranceDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_DUE_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.insuranceOverDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_OVERDUE_")}</p>
                  </span>
                </div>
                <div className="status-values"></div>
              </div>
            </Card>

            <Modal
              open={this.state.insuranceReminder}
              centered
              width={1300}
              onCancel={() => this.setState({ insuranceReminder: false })}
              footer={null}
            >
              <div style={{ height: "600px" }}>
                <div className="heading" style={{ marginBottom: "10px" }}>
                  {this.context.translate("_INSURANCE_REMINDER_")}
                </div>
                <Row style={{ marginBottom: "10px", gap: "10px" }}>
                  <Input
                    // placeholder="Search by Vehicle"
                    placeholder={this.context.translate(
                      "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                    )}
                    style={{ width: 300, height: "36px" }}
                    onChange={async (e) => {
                      let searchedArray =
                        await this.handleSearchinsuranceremainder(
                          e.target.value
                        );

                      await this.setState({
                        driverOrVehicleSearchArrayforinsurance:
                          searchedArray?.length === 0 ? [] : searchedArray,
                      });
                    }}
                    // onChange={(e) => { this.setState({ searchField: e.target.value }) }}
                  />

                  <Button
                    disabled={
                      this.maintenanceDashboardStore?.insuranceExpiryData
                        ?.length > 0
                        ? false
                        : true
                    }
                    style={{
                      backgroundColor: conf.activeColor,
                      height: "36px",
                    }}
                    onClick={(val) => {
                      let result = [];
                      if (true) {
                        this.state.columns5.map((obj) =>
                          result.push(obj.dataIndex)
                        );

                        var getData = {
                          companyId: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).userCompanyId,
                          userCompany: undefined,
                          vehicleStatus: this.state.status,
                          userId: JSON.parse(base64_decode(Cookies.get("data")))
                            .userId,
                          isadmin: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).isadmin,
                          colList: result,
                        };

                        if (val) {
                          this.maintenanceDashboardStore.exportInsuranceExcel(
                            getData
                          );
                        }
                      }
                    }}
                  >
                    {/* Export */}
                    {this.context.translate("_EXPORT_")}
                  </Button>

                  <AntTooltip
                    title={this.context.translate("_UPDATE_VALUES_")}
                    placement={"bottom"}
                  >
                    <Button
                      type="primary"
                      style={{ height: "36px" }}
                      onClick={() =>
                        this.updatedistanceAll({ state: "insuranceReminder" })
                      }
                    >
                      <i class="bi bi-arrow-clockwise"></i>
                    </Button>
                  </AntTooltip>
                </Row>

                <Table
                  components={{
                    header: {
                      cell: ResizableTable,
                    },
                  }}
                  current={this.state.currentPage}
                  total={this.maintenanceDashboardStore?.total}
                  columns={this.getMergedColumns(
                    this.state.columns4,
                    "columns4"
                  )}
                  // columns={this.state.columns5}
                  // dataSource={this.maintenanceDashboardStore?.insuranceExpiryData}
                  dataSource={this.state.driverOrVehicleSearchArrayforinsurance}
                  loading={this.maintenanceDashboardStore?.loading}
                  // onChange={this.handleTableChange}
                />
              </div>
            </Modal>

            <Card
              className="maintenance-dashboard-tiles batteryChange-reminder"
              onClick={async () => {
                await this.setState({
                  batteryChangeReminder: true,
                  status: "batteryData",
                });
                await this.handleChange();
              }}
            >
              {/* Left Section */}
              <div className="maintainance_tile_content-left">
                <div className="icon-section">
                  <Image src={Battery}></Image>
                </div>
                <div className="service-text">
                  <p className="service-count">
                    {
                      this.maintenanceDashboardStore?.maintenanceData
                        ?.totalbattery
                    }
                  </p>
                  <p className="service-label">
                    {this.context.translate("_BATTERY_CHANGE_REMINDER_")}
                  </p>
                </div>
              </div>

              {/* Right Section */}
              <div className="maintainance_tile_content-right">
                <div className="status-labels">
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.batteryUpcoming
                      }
                    </h6>
                    <p>{this.context.translate("_UPCOMING_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.batteryDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_DUE_")}</p>
                  </span>
                  <span className="status-values">
                    <h6>
                      {
                        this.maintenanceDashboardStore?.maintenanceData
                          ?.batteryOverDue
                      }
                    </h6>{" "}
                    <p>{this.context.translate("_OVERDUE_")}</p>
                  </span>
                </div>
                <div className="status-values"></div>
              </div>
            </Card>

            <Modal
              open={this.state.batteryChangeReminder}
              centered
              width={1300}
              onCancel={() => this.setState({ batteryChangeReminder: false })}
              footer={null}
            >
              <div style={{ height: "600px" }}>
                <div className="heading" style={{ marginBottom: "10px" }}>
                  {this.context.translate("_BATTERY_CHANGE_REMINDER_")}
                </div>
                <Row style={{ marginBottom: "10px", gap: "10px" }}>
                  <Input
                    // placeholder="Search by Vehicle"
                    placeholder={this.context.translate(
                      "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                    )}
                    style={{ width: 300, height: "36px" }}
                    onChange={async (e) => {
                      let searchedArray =
                        await this.handleSearchbatteryremainder(e.target.value);

                      await this.setState({
                        driverOrVehicleSearchArrayforbattery:
                          searchedArray?.length === 0 ? [] : searchedArray,
                      });
                    }}
                    // onChange={(e) => { this.setState({ searchField: e.target.value }) }}
                  />

                  <Button
                    disabled={
                      this.maintenanceDashboardStore?.batteryExpiryData
                        ?.length > 0
                        ? false
                        : true
                    }
                    style={{
                      backgroundColor: conf.activeColor,
                      height: "36px",
                    }}
                    onClick={(val) => {
                      let result = [];
                      if (true) {
                        this.state.columns6.map((obj) =>
                          result.push(obj.dataIndex)
                        );

                        var getData = {
                          companyId: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).userCompanyId,
                          userCompany: undefined,
                          vehicleStatus: this.state.status,
                          userId: JSON.parse(base64_decode(Cookies.get("data")))
                            .userId,
                          isadmin: JSON.parse(
                            base64_decode(Cookies.get("data"))
                          ).isadmin,
                          colList: result,
                        };

                        if (val) {
                          this.maintenanceDashboardStore.exportBatteryExcel(
                            getData
                          );
                        }
                      }
                    }}
                  >
                    {/* Export */}
                    {this.context.translate("_EXPORT_")}
                  </Button>

                  <AntTooltip
                    title={this.context.translate("_UPDATE_VALUES_")}
                    placement={"bottom"}
                  >
                    <Button
                      type="primary"
                      style={{ height: "36px" }}
                      onClick={() =>
                        this.updatedistanceAll({
                          state: "batteryChangeReminder",
                        })
                      }
                    >
                      <i class="bi bi-arrow-clockwise"></i>
                    </Button>
                  </AntTooltip>
                </Row>

                <Table
                  components={{
                    header: {
                      cell: ResizableTable,
                    },
                  }}
                  pagination={false}
                  current={this.state.currentPage}
                  total={this.maintenanceDashboardStore?.total}
                  // columns={this.state.columns6}
                  columns={this.getMergedColumns(
                    this.state.columns6,
                    "columns6"
                  )}
                  // dataSource={this.maintenanceDashboardStore?.batteryExpiryData}
                  dataSource={this.state.driverOrVehicleSearchArrayforbattery}
                  loading={this.maintenanceDashboardStore?.loading}
                  // onChange={this.handleTableChange}
                  scroll={{ y: 450 }}
                />
              </div>
            </Modal>
          </div>
        </div>

        <br></br>
        <Row style={{ justifyContent: "space-between" }}>
          <Card
            // title="Monthly Expenses"
            title={this.context.translate("_Monthly_Expenses_")}
            style={{ width: "49%", padding: "10px", marginInlineStart: "0" }}
          >
            {/* <p>Cost(In Thousand)</p> */}
            <p style={{ padding: "6px" }}>
              {this.context.translate("_Cost_InThousand_")}
            </p>

            {this.maintenanceDashboardStore?.monthlyMaintenanceData?.length >
            0 ? (
              <ResponsiveContainer height={300}>
                <BarChart
                  width={500}
                  data={this.maintenanceDashboardStore?.monthlyMaintenanceData}
                  layout="horizontal"
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="vehicleNo" type="category" />{" "}
                  {/* Assuming 'vehicleNo' is a numeric value, use type="number" */}
                  <YAxis type="number" />
                  <Tooltip content={this.CustomTooltip}></Tooltip>
                  <Bar dataKey="sumAmount" stackId="a" fill="orange" />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </Card>

          <Card
            // title="Weekly Expenses"
            title={this.context.translate("_Weekly_Expenses_")}
            style={{ width: "49%", padding: "10px" }}
          >
            <p style={{ padding: "6px" }}>
              {this.context.translate("_Cost_InThousand_")}
            </p>
            {this.maintenanceDashboardStore?.weeklyMaintenanceData?.length >
            0 ? (
              <ResponsiveContainer height={300}>
                <BarChart
                  width={500}
                  data={this.maintenanceDashboardStore?.weeklyMaintenanceData}
                  layout="horizontal"
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="vehicleNo" type="category" />{" "}
                  {/* Assuming 'vehicleNo' is a numeric value, use type="number" */}
                  <YAxis type="number" />
                  <Tooltip content={this.CustomTooltip}></Tooltip>
                  <Bar dataKey="sumAmount" stackId="a" fill="orange" />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </Card>
        </Row>
        <br></br>

        <Card
          // title="Reminders"
          title={this.context.translate("_REMINDERS_")}
          style={{
            padding: "6px",
          }}
        >
          <Row>
            <Col span={12}>
              <ResponsiveContainer width="100%" height={250}>
                <PieChart width={500} height={400}>
                  <Pie
                    data={this.maintenanceDashboardStore.piChartDta}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={this.renderCustomizedLabel}
                    outerRadius={120}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {this.maintenanceDashboardStore.piChartDta?.map(
                      (entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={this.getColorByName(entry.name)}
                        />
                      )
                    )}
                  </Pie>
                  <Tooltip content={<this.piechart_tooltip />} />
                </PieChart>
              </ResponsiveContainer>
            </Col>
            <Col span={12} style={{ marginTop: "80px" }}>
              <Space>
                <Button
                  style={{ backgroundColor: "#157fcc", cursor: "auto" }}
                ></Button>
                <b>
                  {
                    this.maintenanceDashboardStore?.maintenanceData
                      ?.totalService
                  }
                </b>
                {/* Service */}
                {this.context.translate("_SERVICE_")}
                <Button
                  style={{ backgroundColor: "#57caeb", cursor: "auto" }}
                ></Button>
                <b>
                  {this.maintenanceDashboardStore?.maintenanceData?.totalTire}
                </b>
                {/* Tire Change */}
                {this.context.translate("_TYRE_CHANGE_")}
                <Button
                  style={{ backgroundColor: "#ff7976", cursor: "auto" }}
                ></Button>
                <b>
                  {this.maintenanceDashboardStore?.maintenanceData?.totalOil}
                </b>
                {/* Oil Change */}
                {this.context.translate("_OIL_CHANGE_")}
              </Space>
              <br />
              <Space style={{ marginTop: "20px" }}>
                <Button
                  style={{ backgroundColor: "#5ddab4", cursor: "auto" }}
                ></Button>
                <b>
                  {
                    this.maintenanceDashboardStore?.maintenanceData
                      ?.totalMulkiya
                  }
                </b>
                Mulkiya
                {/* {this.context.translate("_ISTIMARA_")} */}
                &nbsp;&nbsp;
                <Button
                  style={{ backgroundColor: "#fda54f", cursor: "auto" }}
                ></Button>
                <b>
                  {
                    this.maintenanceDashboardStore?.maintenanceData
                      ?.totalInsurance
                  }
                </b>
                {/* Insurance  */}
                {this.context.translate("_INSURANCE_")}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  style={{ backgroundColor: "#eb5bbb", cursor: "auto" }}
                ></Button>
                <b>
                  {
                    this.maintenanceDashboardStore?.maintenanceData
                      ?.totalbattery
                  }
                </b>
                {/* Battery Change Reminder */}
                {this.context.translate("_BATTERY_CHANGE_REMINDER_")}
              </Space>
            </Col>
          </Row>
        </Card>
        <Modal
          title="Action"
          open={this.state.openactionmodal}
          onCancel={() => this.setState({ openactionmodal: false })}
          footer={[null]}
          width={400}
        >
          <div>
            <Form layout="vertical" onFinish={this.onActionSubmit}>
              <Form.Item label="Km" name="changeValue">
                <Input></Input>
              </Form.Item>

              <Form.Item label="Date" name="changeValueServiceDate">
                <DatePicker></DatePicker>
              </Form.Item>

              <div className="formBtnGroup">
                <Space style={{ padding: 10 }}>
                  <Button
                    type="primary"
                    className="formSaveButton"
                    htmlType="submit"
                  >
                    {/* Save */}
                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                  </Button>
                </Space>
              </div>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Action"
          open={this.state.openactiofortyre}
          onCancel={() => this.setState({ openactiofortyre: false })}
          footer={[null]}
          width={400}
        >
          <div>
            <Form layout="vertical" onFinish={this.onActiontyreSubmit}>
              <Form.Item label="Km" name="changeValue">
                <Input></Input>
              </Form.Item>

              <Form.Item label="Date" name="changeValueServiceDate">
                <DatePicker></DatePicker>
              </Form.Item>

              <div className="formBtnGroup">
                <Space style={{ padding: 10 }}>
                  <Button
                    type="primary"
                    className="formSaveButton"
                    htmlType="submit"
                  >
                    {/* Save */}
                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                  </Button>
                </Space>
              </div>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Action"
          open={this.state.openactioforoil}
          onCancel={() => this.setState({ openactioforoil: false })}
          footer={[null]}
          width={400}
        >
          <div>
            <Form layout="vertical" onFinish={this.onActionOilSubmit}>
              <Form.Item label="Km" name="changeValue">
                <Input></Input>
              </Form.Item>

              <Form.Item label="Date" name="changeValueServiceDate">
                <DatePicker></DatePicker>
              </Form.Item>

              <div className="formBtnGroup">
                <Space style={{ padding: 10 }}>
                  <Button
                    type="primary"
                    className="formSaveButton"
                    htmlType="submit"
                  >
                    {/* Save */}
                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                  </Button>
                </Space>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}
MaintenanceDashboard.contextType = StoreContext;
export default observer(MaintenanceDashboard);
